import { Component, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { VoiceModalComponent } from 'src/app/layout/modals/voice-modal/voice-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudService } from 'src/app/services/crud.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-ai-agents',
  templateUrl: './ai-agents.component.html',
  styleUrl: './ai-agents.component.css'
})
export class AiAgentsComponent implements OnInit, OnDestroy {
  videos: any[] = [];
  isEmbed: any;
  isLogo: any;
  searchTerm: any;
  isVoiceSearch: boolean = false;
  userId:any;
  subClientId:any;
  iframeSrc: SafeResourceUrl;

  messageHandler = (event: MessageEvent) => {

    if (event.data?.type === 'videoSearchResults') {
      this.videos = event.data.results || [];
      console.log("event.data ==> ", event.data)
    }

  };

  constructor(private dialog: MatDialog, private cdRef: ChangeDetectorRef, private activeRoute: ActivatedRoute, private apiService: CrudService, private sanitizer: DomSanitizer){
    this.activeRoute.queryParams.pipe().subscribe(params => { 
      if (params.embed && params.embed === 'true') {
        this.isEmbed = true;
      }
      if (params.nologo && params.nologo === 'true') {
        this.isLogo = true;
      }
      if (params.userId) {
        this.userId = params.userId;
      }
      if (params.subClient) {
        this.subClientId = params.subClient;
      }
    })

    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://ai-video-segment-search-engine.freefusetest.be?userId=${this.userId}&subClientId=${this.subClientId}`
    );
  }


  ngOnInit(): void {
    window.addEventListener('message', this.messageHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageHandler);
  }

  // spinner: boolean;
  // isEmbed: any;
  // isLogo: any;
  // searchTerm: any;
  // isVoiceSearch: boolean = false;
  // apiKey:any;
  // subClientId:any;

  // constructor(private dialog: MatDialog, private cdRef: ChangeDetectorRef, private activeRoute: ActivatedRoute, private apiService: CrudService){
  //   this.activeRoute.queryParams.pipe().subscribe(params => { 
  //     if (params.embed && params.embed === 'true') {
  //       this.isEmbed = true;
  //     }
  //     if (params.nologo && params.nologo === 'true') {
  //       this.isLogo = true;
  //     }
  //     if (params.apiKey) {
  //       this.apiKey = params.apiKey;
  //     }
  //     if (params.subClient) {
  //       this.subClientId = params.subClient;
  //     }
  //   })

  // }

  // openVoiceModal() {
  //   this.isVoiceSearch = true;
  //   const dialogRef = this.dialog.open(VoiceModalComponent, {
  //     width: '100%',
  //     maxWidth: '500px',
  //     panelClass: 'voice-modal',
  //     height: 'auto',
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     this.spinner = false;
  //     if (result) {
  //       // this.spinner = true;
  //       this.cdRef.detectChanges();
  //       this.searchTerm = result.searchTerm;
  //       this.onSearchValue({ target: { key: 'Enter', value: this.searchTerm } });
  //       this.cdRef.detectChanges();
  //     }
  //   });
  
  // }

  // removeSearchText(){
  //   this.searchTerm = null;
  //   this.cdRef.detectChanges();
  // }

  // onSearchValue(event: any) {
  //   this.spinner = true;
  //   this.searchTerm = event.target.value
  //   console.log('this.searchTerm: ', this.searchTerm);

  // const payload = {
  //   userId: this.apiKey,
  //   subClientId: this.subClientId,
  //   searchQuery: this.searchTerm
  // }

  //   this.apiService.videoSegmentSemanticSearch(payload).subscribe((res:any) => {
  //     console.log("res ==> ", res)
  //     this.spinner = false;

  //     window.parent.postMessage({
  //       type: 'videoSearchResults',
  //       query: this.searchTerm,
  //       results: res.data.searchResults, // assuming `res` is an array
  //     }, '*'); // Replace '*' with your specific domain for security
      
  //   }, error => {
  //     this.spinner = false;
  //     console.log("error", error)
  //   })
  // }
}